import React, { useState, useEffect } from "react";


const NewSubscriptionRoute = () => {
 
  // return auth && auth ? Component : <Navigate to={"/signin"} />;
  return (
      <>
    <div className="">
    
        </div>
            
      </>
  );
};

export default NewSubscriptionRoute;



